import { styled, Box } from "@mui/material";

export const StartScreenRoot = styled(Box)(({ theme }) => ({
  position: "absolute",
  zIndex: 9999,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "2rem",
  padding: 0,
  height: "100%",
  width: "100%",
  boxSizing: "border-box",
  background: theme?.palette?.companyColors?.black,
  [theme.breakpoints.down("md")]: {
    gap: 0,
    padding: 0,
    "@media (orientation: landscape)": {
      gap: "2rem",
      flexDirection: "row",
      paddingTop: 0,
    },
  },
  [theme.breakpoints.up("xl")]: {
    "@media (orientation: landscape)": {
      paddingTop: 0,
    },
    flexDirection: "row",
  },
  "& .start-screen__content": {
    padding: "3dvh 15dvw",
    [theme.breakpoints.down("xl")]: {
      padding: "0 10vw",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 10vw 0",
      "@media (orientation: landscape)": {
        paddingRight: "2vw",
        alignItems: "flex-end",
      },
    },
  },
  "& .start-screen__image": {
    opacity: 0,
    animation: "fadeInScale 2s 2s ease-out forwards",
    [theme.breakpoints.up("md")]: {
      animation: "fadeInSlide 2.5s 2s ease-out forwards",
    },
  },
  "& .start-screen__loading__dot": {
    "&:nth-of-type(1)": {
      animation: "opacityDots1 3s infinite forwards ease",
    },
    "&:nth-of-type(2)": {
      animation: "opacityDots2 3s infinite forwards ease",
    },
    "&:nth-of-type(3)": {
      animation: "opacityDots3 3s infinite forwards ease",
    },
  },
  "& .start-screen__title": {
    "& span": {
      fontFamily: "inherit",
      display: "block",
      opacity: 0,
      animation: "fadeInSlide 2.5s 1s ease-out forwards",
      "&:nth-of-type(2)": {
        marginTop: "-6rem",
        marginLeft: "12rem",
        textTransform: "uppercase",
        animationDuration: "3s",
        animationDelay: "1.5s",
        [theme.breakpoints.down("lg")]: {
          marginTop: "-3.2rem",
        },
        [theme.breakpoints.down("md")]: {
          marginTop: "-2.4rem",
          marginLeft: "6rem",
        },
        [theme.breakpoints.down("sm")]: {
          marginLeft: 0,
        },
      },
    },
  },
  "& .start-screen__details": {
    opacity: 0,
    animation: "fadeIn 2.5s 2s ease-out forwards",
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
  "@keyframes fadeInSlide": {
    "0%": {
      opacity: 0,
      transform: "translateX(-3rem)",
    },
    "100%": {
      opacity: 1,
      transform: "translateX(0)",
    },
  },
  "@keyframes fadeInScale": {
    "0%": {
      opacity: 0,
      transform: "scale(1.2)",
    },
    "100%": {
      opacity: 1,
      transform: "scale(1)",
    },
  },
  "@keyframes opacityDots1": {
    "0%": {
      opacity: 1,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes opacityDots2": {
    "0%": {
      opacity: 0,
    },
    "33%": {
      opacity: 1,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes opacityDots3": {
    "0%": {
      opacity: 0,
    },
    "33%": {
      opacity: 0,
    },
    "66%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
}));
